import md from '@/routes/middlewares';

import AnalysisRequests from '@/views/laboratory/AnalysisRequests.vue';
import Laboratory from '@/views/laboratory/Laboratory.vue';
import WorkOrders from '@/views/laboratory/WorkOrders.vue';
import SamplesRegister from '@/views/laboratory/SamplesRegister.vue';
import dataTransfer from '@/views/laboratory/DataTransfer.vue';
import xmlReport from '@/views/laboratory/XMLReport.vue';
import labReports from '@/views/laboratory/LabReports.vue';
import labWorkOrder from '@/routes/client/site/labWorkOrder';

const laboratory = {
    path: '/laboratory',
    name: 'laboratory',
    component: Laboratory,
    meta: {
        middlewares: [
            md.auth,
            md.accessControl,
            md.isNotOperator,
        ],
    },
    redirect: { name: 'analysisRequests' },
    children: [
        labWorkOrder,
        {
            path: 'analysisRequests',
            name: 'analysisRequests',
            component: AnalysisRequests,
        },
        {
            path: 'labWorkOrders',
            name: 'labWorkOrders',
            component: WorkOrders,
        },
        {
            path: 'samplesRegister',
            name: 'samplesRegister',
            component: SamplesRegister,
        },
        {
            path: 'dataTransfer',
            name: 'dataTransfer',
            component: dataTransfer,
        },
        {
            path: 'labReports',
            name: 'labReports',
            component: labReports,
        },
        {
            path: 'xmlReport',
            name: 'xmlReport',
            component: xmlReport,
        },
    ],
};

export default laboratory;
